import { defineRule, configure } from 'vee-validate'
import { required, email, min, max, numeric } from '@vee-validate/rules'
import { localize, setLocale } from '@vee-validate/i18n'
import fr from '@vee-validate/i18n/dist/locale/fr.json'

// Définir les règles
defineRule('required', required)
defineRule('email', email)
defineRule('min', min)
defineRule('max', max)
defineRule('numeric', numeric)

// Configuration avec traductions françaises
configure({
  generateMessage: localize({
    fr,
  }),
})

// Définir le français par défaut
setLocale('fr')
